import { Skeleton } from "@mui/material";
import React from "react";
import classes from "../../../assets/css/CustomerDetails.module.css";
function CustomerFormSkeleton({ loading, children }) {
  return loading ? (
    <Skeleton
      animation="wave"
      variant="rectangular"
      className={classes["skeleton_style"]}
    />
  ) : (
    children
  );
}

export default CustomerFormSkeleton;
